export const joinProcessTractorWantBuyCheckConstants = {
  key: '트랙터 구매 의사',
  values: ['구매 예정', '없음'],
  labels: [],
};
